import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl } from 'react-intl'
import { SubmissionError } from 'redux-form'
import { LABEL_NAME_MAX_LENGTH } from 'const/limits'
import CreateLabelForm from './CreateLabelForm'
import classes from '../Labels.module.scss'

export class CreateLabel extends React.Component {
  static propTypes = {
    cardContext: PropTypes.object.isRequired,

    intl: PropTypes.object.isRequired,

    requestAddNewLabel: PropTypes.func.isRequired,

    name: PropTypes.string.isRequired,
    onCancelClick: PropTypes.func.isRequired,
  }

  handleFormSubmit = ({ name, color }) => {
    const { cardContext, intl, requestAddNewLabel, onCancelClick } = this.props

    return new Promise((resolve) => {
      if (!name) {
        throw new SubmissionError({
          name: intl.formatMessage({ id: 'LABEL_EMPTY' })
        })
      } else if (name.length > LABEL_NAME_MAX_LENGTH) {
        throw new SubmissionError({
          name: intl.formatMessage(
            { id: 'LABEL_TOO_LONG' },
            { limit: LABEL_NAME_MAX_LENGTH }
          )
        })
      }

      requestAddNewLabel({
        cardId: cardContext.id,
        name,
        color
      })

      resolve()

      onCancelClick()
    })
  }

  render () {
    const {
      name,
      onCancelClick
    } = this.props

    return (
      <div className={classes.createLabel}>
        <CreateLabelForm
          form='createLabel'
          initialValues={{
            name,
            color: Math.floor(Math.random() * 16)
          }}
          onSubmit={this.handleFormSubmit}
          onCancelClick={onCancelClick}
        />
      </div>
    )
  }
}

export default injectIntl(CreateLabel)
